import React, { useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import Button from "../../Components/RequestsOverView/Button";
import DateTimePicker from "../../ReusableComponents/DateTimePicker";

export default function FollowUpPopup({
    open,
    onClose,
    onRaiseFollowUp,
}) {
    // Current time + 15 minutes
    const now = new Date();
    const defaultDate = new Date(now.getTime() + 15 * 60 * 1000);

    const [selectedDate, setSelectedDate] = useState(defaultDate);

    // "Today" (midnight)
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    // Is selected date today?
    const isToday =
        selectedDate &&
        new Date(selectedDate).toDateString() === today.toDateString();

    // Minimum allowed time
    const minTime = isToday
        ? new Date(now.getTime() + 15 * 60 * 1000) // 15 minutes ahead
        : new Date().setHours(0, 0, 0, 0);

    const maxTime = new Date().setHours(23, 59, 59, 999);

    return (
        <Modal
            header="Schedule Follow Up"
            open={open}
            onClose={onClose}
            contentStyle={{
                width: "670px",
                height: "auto",
                boxShadow:
                    "0px 1.02px 4.09px 6.14px rgba(118, 118, 118, 0.15)",
            }}
            divider={true}
            headerContainerStyle={{ padding: "20px 25px" }}
            headingStyle={{ fontSize: "16px", fontWeight: 600 }}
            iconSize="18px"
        >
            <div className="flex flex-col justify-between">
                <div className="flex w-full justify-between py-4 px-8">
                    <div className="flex flex-col w-full">
                        <span className="py-2">Schedule Date</span>

                        <DateTimePicker
                            selectedDateTime={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            minDate={today} // can't select past dates
                            minTime={new Date(minTime)}
                            hidePrev={new Date()}
                            maxTime={new Date(maxTime)}
                        />
                    </div>
                </div>

                <div className="flex ml-auto px-8 py-6 gap-6">
                    <Button
                        color="#606571"
                        variant="outlined"
                        title="Cancel"
                        width="80px"
                        handleClick={onClose}
                    />
                    <Button
                        color="#0F5EFF"
                        isDisbaled={false}
                        variant="filled"
                        title="Ok"
                        width="80px"
                        hoverColor="#1251D2"
                        handleClick={() => {
                            if (onRaiseFollowUp) {
                                onRaiseFollowUp(selectedDate);
                            }
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
}
